// extracted by mini-css-extract-plugin
export default {"cls1":"VeloPhoneNumberField-CountryCodeLabel_cls1__DpE8X","cls2":"VeloPhoneNumberField-CountryCodeLabel_cls2__QvCYj VeloPhoneNumberField-CountryCodeLabel_cls1__DpE8X"};